import React, { useState, useEffect, useCallback } from "react";
import "../../styles/desktop/main.css";
import CampoImagem from "../CampoImagem/campoimagem";
import Menu from "../menu/menu";
import TextMain from "../Texto Principal/textoMain";
import Agendamentos from "../Agendamento/agendamento";
import Loader from "../loader/loader";
import Gestao from "../Gestao/gestao";
import Exaustor from "../Exaustores/exaustores"; 
import Eventos from "../events/eventos";
import background from "../../assets/img/background.png";

import pagina1 from "../../assets/img/Pagina01.jpg";
import pagina2 from "../../assets/img/Pagina02.png";
import pagina3 from "../../assets/img/Pagina03.png";
import pagina4 from "../../assets/img/Pagina04.png";

import Grupo01 from "../Campo Luzes/Terreo";
import Grupo02 from "../Campo Luzes/Lazer";
import Grupo03 from "../Campo Luzes/Apoio";
import Grupo04 from "../Campo Luzes/Rooftop";
import Alarme from "../Alarme/AlarmeModal";
import Subsolo from "../Campo Luzes/Subsolos/subsolos";
import Climatizacao from '../Ar Condicionados/ar'
import ChatBot from "../Plus/ChatBot/chatbot";
import PLUS from "../Plus/plus";
import Dispositivos from "../Plus/Dispositivos/dispositivo"

import getRegistrosEventos from "../../API/events/getRegistrosEventos";
import getAllChamados from "../../API/server/getChamados"; // Nova importação
import processEventosEChamados from "../../API/utils/processEventos"; // Nova importação

const Main = () => {
  const [paginaAtual, setPaginaAtual] = useState("Lazer");
  const [loading, setLoading] = useState(true);
  const [loadingImage, setLoadingImage] = useState(false);
  const [imagemCentral, setImagemCentral] = useState(pagina2);
  const [eventos, setEventos] = useState([]);
  const [chamados, setChamados] = useState([]);
  const [filtro, setFiltro] = useState("Todos");
  // eslint-disable-next-line no-unused-vars
  const [fazerRequisicoesChamados, setFazerRequisicoesChamados] = useState(false);

  console.log(imagemCentral);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);


  const loaderImage = useCallback(() => {
    setPaginaAtual(pagina1);
    setLoadingImage(true);
    setTimeout(() => {
      setLoadingImage(false);
    }, 1000);
  }, []);

  const trocarPagina = useCallback((pagina) => {
    console.log(`Trocando para a página: ${pagina}`);
    setPaginaAtual(pagina);
    
    // Ativa ou desativa as requisições de chamados com base na página atual
    if (pagina === "history" || pagina === "Gestao") {
      setFazerRequisicoesChamados(true);
    } else {
      setFazerRequisicoesChamados(false);
    }
    
    if (pagina === "Agendamentos" || pagina === "Alarme" || pagina === "Exaustor" || pagina === "Climatização") {
      setImagemCentral(""); 
    }
    if(pagina === "history") {
      setFiltro("Todos");
    }
  }, []);

  const trocarImagem = useCallback((img) => {
    if (imagemCentral !== img) {
      console.log("Imagem trocada para:", img);
      loaderImage();
      setImagemCentral(img);
    }
  }, [imagemCentral, loaderImage]);

  const groupComponents = {
    [pagina1]: <Grupo01 />,
    [pagina2]: <Grupo02 />,
    [pagina3]: <Grupo03 />,
    [pagina4]: <Grupo04 />,
  };

  const renderGroup = () => {
    return groupComponents[imagemCentral] || groupComponents[paginaAtual] || null;
  };
  // Função para verificar se os dados são diferentes antes de atualizar o estado
  const dadosSaoDiferentes = (novosDados, dadosAtuais) => {
    return JSON.stringify(novosDados) !== JSON.stringify(dadosAtuais);
  };

  // Função para carregar os eventos
  const carregarEventos = async (forceReload = false) => {
    try {
      if (typeof forceReload === 'boolean') {
        setLoading(forceReload);
      } else {
        setLoading(true);
      }
      
      console.log("Buscando eventos e chamados...");
      
      // Busca eventos e chamados em paralelo para melhor performance
      const [eventosData, chamadosData] = await Promise.all([
        getRegistrosEventos(),
        getAllChamados()
      ]);

      console.log(chamadosData)
      
      // Atualiza o estado de chamados se necessário
      if (dadosSaoDiferentes(chamadosData, chamados)) {
        setChamados(chamadosData);
      }
      
      // Processa a relação entre eventos e chamados
      const processedData = processEventosEChamados(eventosData, chamadosData);
      
      // Ordena por data decrescente (mais recente primeiro)
      const sortedData = processedData.sort((a, b) => {
        const [diaA, mesA, anoA] = a.data.split("/");
        const [diaB, mesB, anoB] = b.data.split("/");
        const dateA = new Date(`${anoA}-${mesA}-${diaA}`);
        const dateB = new Date(`${anoB}-${mesB}-${diaB}`);
        return dateB - dateA;
      });

      if (dadosSaoDiferentes(sortedData, eventos)) {
        setEventos(sortedData);
        console.log("Eventos atualizados:", sortedData);
      } else {
        console.log("Eventos não alterados.");
      }
    } catch (error) {
      console.error("Erro ao buscar eventos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarEventos(); // Primeira chamada para carregar os eventos ao montar o componente

    // Configurar intervalo para atualizar os eventos a cada 5 segundos
    const interval = setInterval(() => {
      console.log("Verificando atualização de eventos...");
      carregarEventos(false); // Passa false para não mostrar estado de carregamento nas atualizações periódicas
    }, 5000);

    // Limpa o intervalo ao desmontar o componente para evitar vazamentos de memória
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div id="divMain">
      {loading ? <Loader /> : null}
      <Menu
        trocarPagina={trocarPagina}
        trocarImagem={trocarImagem}
        paginaAtual={paginaAtual}
        paginas={[pagina1, pagina2, pagina3, pagina4]}
      />
      <div id="content" style={{ backgroundImage: `url(${background})` }}>
        <TextMain />
        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">
            {paginaAtual === "Agendamentos" ? (
              <Agendamentos />
            ) : paginaAtual === "Exaustor" ? (
              <Exaustor />
            ) : paginaAtual === "Climatização" ? (
              <Climatizacao />
            ): paginaAtual === "Chatbot" ? (
              <ChatBot />
            ) : paginaAtual === "history" ? (
            <Eventos
              filtro={filtro}
              eventos={eventos}
              loading={loading}
              getData={carregarEventos}
            />
            ) : paginaAtual === "PLUS" ? (
              <PLUS />
            ) : paginaAtual === "Dispositivos" ? (
              <Dispositivos />
            ) : paginaAtual === "Alarme" ? (
              <Alarme />
            ) : paginaAtual === "Subsolo" ? (
              <Subsolo />
            ) : (
              <>
                {imagemCentral && <CampoImagem imagem={imagemCentral} loadingImage={loadingImage} />}
                {renderGroup()}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Main;